import { getCookie } from 'cookies-next/client';

import { VARIANT_A_IDENTIFIER, VARIANT_B_IDENTIFIER } from './config';
import { COMBINED_FLOW_COOKIE_VALUE } from './helpers/setCombinedFlowCookie';
import { useExperiments } from './useExperiments';

import { COMBINED_FLOW_LAYOUT } from '@/constants/cookies';

export function useCombinedFlowVariants() {
  const [{ web_9287_combined_signup_checkout_v2 }] = useExperiments(
    ['web_9287_combined_signup_checkout_v2'],
    { deferred: true }
  );

  const inCombinedFlow =
    getCookie(COMBINED_FLOW_LAYOUT) === COMBINED_FLOW_COOKIE_VALUE;

  return {
    isVariantA:
      inCombinedFlow &&
      web_9287_combined_signup_checkout_v2 === VARIANT_A_IDENTIFIER,
    isVariantB:
      inCombinedFlow &&
      web_9287_combined_signup_checkout_v2 === VARIANT_B_IDENTIFIER,
  };
}

export function useIsCombinedFlowVariant() {
  const { isVariantA, isVariantB } = useCombinedFlowVariants();
  return isVariantA || isVariantB;
}
